import script from "./DisciplinePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./DisciplinePage.vue?vue&type=script&lang=ts&setup=true"

import "./DisciplinePage.vue?vue&type=style&index=0&id=6487d216&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6487d216"]])

export default __exports__